import React from "react";
import { baseUrl, siteTitle, twitter } from "../vars/ThemeOptions";
import Layout from "../components/layout/MainLayout";
import { SEO } from "wmk-lib";
import { dataHash } from "./pageDataHash";
import get from "lodash/get";

export default ({ pageContext }) => {
  const route = get(pageContext, "slug");
  const renderData = get(dataHash, route);
  // console.log('renderData: ', renderData);
  const RenderComponent = get(renderData, 'RenderComponent');
  const layoutProps = get(renderData, 'layoutProps');
  return renderData ? (
    <Layout layoutProps={layoutProps}>
      <SEO
        title={pageContext.title}
        path=""
        slug={pageContext.slug}
        // description={desc}
        ogImage={null}
        twitterImage={null}
        twitterHandle={twitter}
        siteTitle={siteTitle}
        baseUrl={baseUrl}
      />
      {RenderComponent}
    </Layout>
  ) : null;
};
